import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NavigationService} from "../../services/navigation.service";
import {ActionSheetController, ModalController} from "@ionic/angular";
import {Product, ProductStatus} from "../../models/ent-product.model";
import {ApiService} from "../../services/api.service";
import {FavoritesService} from "../../services/favorites.service";
import {Subscription} from "rxjs";
import { FormNewProductComponent } from './../form-new-product/form-new-product.component';
import { ProductService } from './../../services/product.service';
import {ChatService} from "../../services/chat.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  $favoritesSubscription!: Subscription;
  @Input() pageTitle?: string;
  @Input() back: 'ionic' | 'native' | 'modal' | undefined;
  @Input() backUrl: string | undefined;
  @Input() chatLeaveId: string | undefined;
  @Input() isFavorite: boolean = false;
  @Input() isShare: boolean = false;
  @Input() isNew: boolean = false;
  @Input() isEdit: boolean = false;
  @Input() isRemove: boolean = false;
  @Input() catalogItem?: any;

  constructor(
    public readonly navigationService: NavigationService,
    private readonly modalCtrl: ModalController,
    private readonly actionSheetCtrl: ActionSheetController,
    private readonly api: ApiService,
    private readonly favoritesService: FavoritesService,
    private readonly productService: ProductService,
    private readonly chatService: ChatService
  ) { }

  ngOnDestroy(): void {
    this.$favoritesSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.subscriptionUpdateFavorite();
  }

  async setFavorite() {
    if (this.catalogItem?.id)
      await this.api.catalog.setFavorite(this.catalogItem?.id, !this.catalogItem?.isFavorite).then(resp => { // @ts-ignore
        this.catalogItem?.isFavorite = resp.isFavorite;
        this.favoritesService.update$.next({ action: true, id: this.catalogItem?.id });
      });
  }

  subscriptionUpdateFavorite() {
    this.$favoritesSubscription = this.favoritesService.update$.subscribe(async resp => {
      if (resp?.action && this.catalogItem?.id == resp?.id && this.catalogItem?.id) {
        const _item = await this.api.catalog.catalogItem(this.catalogItem?.id);
        // @ts-ignore
        this.catalogItem.isFavorite = _item.isFavorite;
      }
    });
  }

  share() {
    const shareData = {
      title: this.pageTitle,
      text: '',
      url: window.location.href,
    }
    if (navigator) {
      navigator.share(shareData)
    }
  }

  async closeModal() {
    return await this.modalCtrl.dismiss().then();
  }

  async goToNew() {
    return await this.navigationService.openPageByUrl('/new', {}).then();
  }

  async edit() {
    const _product = await this.api.entProduct.get(this.catalogItem?.id);
    if (_product) {
      const modal = await this.modalCtrl.create({
        component: FormNewProductComponent,
        cssClass: 'create-modal',
        componentProps: {
          'product': _product,
        }
      });
      modal.present().then();

      const { data, role } = await modal.onWillDismiss();

      if (role === 'confirm') {
        if (typeof data !== 'undefined') {
          console.log(data);
        }
      }
    }
  }

  async remove() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: this.catalogItem?.status == ProductStatus.Archive ? 'Вы уверены что хотите удалить объявление ?' : 'Перенести в архив ?',
      buttons: [
        {
          text: this.catalogItem?.status == ProductStatus.Archive ? 'Удалить' : 'Да',
          role: 'destructive',
          data: { action: 'delete' },
          handler: async () => {
            await this.api.entProduct.remove(this.catalogItem?.id, this.catalogItem?.status == ProductStatus.Archive ? ProductStatus.Deleted : ProductStatus.Archive).then();
            console.log(`Removed => ${this.catalogItem?.id}`);
            this.productService.isProductUpdate$.next(true);
            await this.navigationService.openPageByUrl('/ads', {}).then();
          }
        },
        {
          text: 'Отмена', role: 'cancel',
          data: { action: 'cancel' }
        }
      ]
    });
    await actionSheet.present();
  }

  public async chatLeave() {
    if (this.chatLeaveId) {
      const actionSheet = await this.actionSheetCtrl.create({
        header: 'Вы уверены что хотите удалить чат ?',
        subHeader: 'Собеседник по прежнему будет иметь доступ к чату',
        buttons: [
          {
            text: 'Удалить',
            role: 'destructive',
            data: { action: 'delete' },
            handler: async () => {
              await this.api.chat.leave(this.chatLeaveId!).then();
              this.chatService.isNewChat$.next(false);
              await this.navigationService.openPageByUrl('/chat', {}).then();
            }
          },
          {
            text: 'Отмена', role: 'cancel',
            data: { action: 'cancel' }
          }
        ]
      });
      await actionSheet.present();
    }
  }
}
